import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PeopleIcon from '@mui/icons-material/People';
import { compose } from 'redux';
import PartnerRelationsListComponent from './PartnerRelationsListComponent';
import { Grid } from '@mui/material';
import { CollapseCard, Button } from '@totalsoft/rocket-ui';
import ListFilter from '@ts-private/list-filter';
import PaginationWrapper from 'components/common/PaginationWrapper';
import { RightsContext } from 'providers/RightsContext';
import { getListFilterLocalizedStrings } from 'utils/functions';

const sortableColumns = [
  {
    columnName: 'directPartnerName',
    displayName: 'Offer.PartnerRelations.DirectPartner'
  },
  {
    columnName: 'reversePartnerName',
    displayName: 'Offer.PartnerRelations.ReversePartner'
  },
  {
    columnName: 'directRelation',
    displayName: 'Offer.PartnerRelations.DirectRelation'
  },
  {
    columnName: 'relationStartDate',
    displayName: 'Offer.PartnerRelations.RelationStartDate'
  },
  {
    columnName: 'relationExpireDate',
    displayName: 'Offer.PartnerRelations.RelationExpireDate'
  },
  {
    columnName: 'lastUpdateDate',
    displayName: 'Offer.PartnerRelations.LastUpdateDate'
  }
];

const PartnerRelationsListCard = ({
  documentPartnerRelations,
  partnerRelationTypes,
  loaded,
  dispatch,
  partnerRelationsFilter,
  onPropertyChange,
  onSave,
  onAdd,
  onChangeFilterValue,
  cardExpanded,
  onExpand,
  pagination,
  onChangeRowsPerPage,
  onChangePage,
  onRefresh,
  rowsPerPageOptions,
  validation,
  t
}) => {
  const { isImage, clientRelationsWrite } = useContext(RightsContext);

  return (
    <CollapseCard
      id={'partnerRelationsCard'}
      icon={PeopleIcon}
      title={t('Offer.PartnerRelations.Title')}
      expanded={cardExpanded}
      onToggle={onExpand}
      toggleOnHeaderClick
    >
      <Grid container alignItems='center'>
        {!isImage && (
          <Grid item md={2}>
            <Button id={'partnerRelations_addBtn'} onClick={onAdd} disabled={!clientRelationsWrite}>
              {t('Add')}
            </Button>
          </Grid>
        )}
        <Grid item xs={12} sm={10}>
          <ListFilter
            sortableColumns={sortableColumns}
            searchPlaceholder={t('Search')}
            filters={partnerRelationsFilter}
            onChangeFilterValue={onChangeFilterValue}
            downloadEnabled={false}
            entityName={'Facilities'}
            localizedStrings={getListFilterLocalizedStrings(t)}
          />
        </Grid>
        {!loaded ? (
          <> </>
        ) : (
          <>
            <PartnerRelationsListComponent
              documentPartnerRelations={documentPartnerRelations}
              partnerRelationTypes={partnerRelationTypes}
              onExpand={onExpand}
              cardExpanded={cardExpanded}
              dispatch={dispatch}
              onPropertyChange={onPropertyChange}
              onSave={onSave}
              validation={validation}
            />
            <br />
            <Grid item xs={12}>
              <PaginationWrapper
                loading={false}
                count={pagination.totalCount}
                pageSize={pagination.pageSize}
                page={pagination.page}
                rowsPerPageOptions={rowsPerPageOptions}
                onRowsPerPageChange={onChangeRowsPerPage}
                onPageChange={onChangePage}
                onRefresh={onRefresh}
              />
            </Grid>
          </>
        )}
      </Grid>
    </CollapseCard>
  );
};
PartnerRelationsListCard.propTypes = {
  documentPartnerRelations: PropTypes.array,
  partnerRelationTypes: PropTypes.array,
  onExpand: PropTypes.func.isRequired,
  cardExpanded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  partnerRelationsFilter: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  loaded: PropTypes.bool
};

export default compose(withTranslation())(PartnerRelationsListCard);
